/**
 * Tipos de ocorrência do histórico da venda: bloco comum 1 a 9 e específicos a partir de 20.
 * Espelha venda_tipo_ocorrencia (db_vendas) e VendaTipoOcorrenciaEnum (API Vendas e OrquestradorVendas).
 * Nome e ícone vêm do catálogo no struct da ocorrência.
 */
export enum VendaTipoOcorrenciaEnum {
    Criacao = 1,
    Edicao = 2,
    MudancaEtapa = 3,
    Exclusao = 4,
    Anotacao = 5,
    Liberacao = 6,
    IntegracaoLancada = 7,
    IntegracaoExcluida = 8,
    FalhaIntegracao = 9,
    Conversao = 20,
    MigracaoEtapa = 21,
    ReservaEstoque = 22,
    Compartilhamento = 23,
    Impressao = 24,
    RemocaoDeItem = 25,
    VinculoOportunidade = 26,
    DesvinculoOportunidade = 27,
    /** Aviso da automação "Liberar reserva do pedido" enviado aos destinatários (gravado pelo Worker Vendas). */
    AvisoReserva = 28,
}
